module.exports = __webpack_public_path__ + "static/media/jamiaHamdardLogo.bd4c51da.png";